// extracted by mini-css-extract-plugin
export var documentation = "_lb-1";
export var menu = "_lb-0";